
const getApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.REACT_APP_API_BASE_URL) {
    return window.REACT_APP_API_BASE_URL;
  }
  return process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';
};

const getSocketUrl = () => {
  if (typeof window !== 'undefined' && window.REACT_APP_SOCKET_URL) {
    return window.REACT_APP_SOCKET_URL;
  }
  return process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_BASE_URL || getApiBaseUrl();
};

export const API_CONFIG = {
  
  get baseURL() {
    return getApiBaseUrl();
  },
  set baseURL(value) {
    if (typeof window !== 'undefined') {
      window.REACT_APP_API_BASE_URL = value;
    }
  },
  get socketURL() {
    return getSocketUrl();
  },
  set socketURL(value) {
    if (typeof window !== 'undefined') {
      window.REACT_APP_SOCKET_URL = value;
    }
  },
  
  
  endpoints: {
    pricing: '/api/pricing',
    skidata: '/api/skidata',
    skiPasses: '/api/ski-passes',
    orders: '/api/orders',
    health: '/health'
  },
  
  
  timeout: 10000, 
  
  
  isDevelopment: process.env.NODE_ENV === 'development',
  // Check if we're in production: either NODE_ENV is 'production' OR API base URL is not localhost
  isProduction: process.env.NODE_ENV === 'production' || 
                (process.env.REACT_APP_API_BASE_URL && !process.env.REACT_APP_API_BASE_URL.includes('localhost')),
  // Allow showing production tabs on localhost for testing (set REACT_APP_SHOW_PROD_TABS=true)
  showProdTabs: process.env.REACT_APP_SHOW_PROD_TABS === 'true' || 
                (process.env.NODE_ENV === 'production' || 
                 (process.env.REACT_APP_API_BASE_URL && !process.env.REACT_APP_API_BASE_URL.includes('localhost'))),
  debug: process.env.REACT_APP_DEBUG === 'true',
};


export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`;
};


export const apiUrls = {
  get pricing() {
    return buildApiUrl(API_CONFIG.endpoints.pricing);
  },
  get pricingStatus() {
    return buildApiUrl(API_CONFIG.endpoints.pricing + '/status');
  },
  get skidataProducts() {
    return buildApiUrl(API_CONFIG.endpoints.skidata + '/products');
  },
  get health() {
    return buildApiUrl(API_CONFIG.endpoints.health);
  },
  get orders() {
    return buildApiUrl(API_CONFIG.endpoints.orders);
  },
  get ordersCheckout() {
    return buildApiUrl(API_CONFIG.endpoints.orders + '/liqpay-checkout');
  },
};
